export class EmptyValueHelper {
  public static isEmptyStringValue(value: string):boolean {
    return (value === undefined || value === null ||
      (typeof value === 'string' && value.trim() ===  ''));
  }
}
